// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import siteMessage from "@insite/client-framework/SiteMessage";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { ProductLineComponentModel } from "@store/Library/Components/ProductLine/ProductLine";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC, useContext } from "react";

export interface ProductLineAddToListLinkProps {
    productLine?: ProductLineComponentModel;
}

export interface ProductLineAddToListLinkStyles {
    link?: LinkPresentationProps;
}

export const ProductLineAddToListLinkStyles: ProductLineAddToListLinkStyles = {
    link: linkGetActionLinkProps(PlusCircleFill),
};

const styles = ProductLineAddToListLinkStyles;

const ProductLineAddToListLink: FC<ProductLineAddToListLinkProps> = ({ productLine }) => {
    const dispatch = useAppDispatch();
    const { wishListSettings } = useSettingsCollection();
    const toasterContext = useContext(ToasterContext);

    if (!productLine || !productLine.canAddToWishlist || productLine.isRestricted) {
        return null;
    }

    const onClick = () => {
        const productInfo = {
            productId: productLine.productId!,
            qtyOrdered: productLine.qtyOrdered!,
            unitOfMeasure: productLine.unitOfMeasure!,
        };

        if (!wishListSettings.allowMultipleWishLists) {
            dispatch(
                addToWishList({
                    productInfos: [productInfo],
                    onSuccess: () => {
                        toasterContext.addToast({ body: siteMessage("Lists_ProductAdded"), messageType: "success" });
                    },
                    onComplete(resultProps) {
                        if (resultProps.result?.wishList) {
                            this.onSuccess?.(resultProps.result.wishList);
                        } else if (resultProps.result?.errorMessage) {
                            toasterContext.addToast({ body: resultProps.result.errorMessage, messageType: "danger" });
                        }
                    },
                }),
            );

            return;
        }

        dispatch(setAddToListModalIsOpen({ modalIsOpen: true, productInfos: [productInfo] }));
    };

    return (
        <Link {...styles.link} onClick={onClick}>
            {translate("Add to List")}
        </Link>
    );
};

export default ProductLineAddToListLink;
